import { DashMessage } from "./DashMessage"

export const ErrorMessage = () => {
    return (
        <DashMessage
            icon={"error"}
            fill={false}
            title={"Something Went Wrong!"}
            description={"Refresh the page and try again."}
            buttonText={"Refresh"}
            onClick={() => window.location.reload()}
        />
    )
}